module.exports = __webpack_public_path__ + "img/PeachLogo.c80ae935.png";